import Dialog from 'material-ui/Dialog'
import Table from './components/table'
import * as S from './styled'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import Button from 'components/button'

const Modal = ({ tasks, open, close }) => {
  const copyToClipboard = () => {
    const text = tasks.map((task) => task.ChaveAcesso).join(' ');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        const tooltip = document.getElementById("myTooltip")
        tooltip.innerHTML = intl.get('accessKeyModal.copied')
      })
    }
  }

  const onMouseOutTooltip = () => {
    const tooltip = document.getElementById("myTooltip")
    tooltip.innerHTML = intl.get('accessKeyModal.copy')
  }

  return (
    <S.DialogWrapper>
      <Dialog
        open={open}
        title={
          <S.WrapperHeader>
            <S.Title>
              {intl.get('accessKeyModal.title')}
            </S.Title>
            <div className='tooltip'>
              <S.Button onMouseOut={() => onMouseOutTooltip()}>
                <div className="tooltiptext" id="myTooltip">{intl.get('accessKeyModal.copy')}</div>
                <Button
                  value={intl.get('accessKeyModal.copyAll')}
                  buttonType="primary"
                  onClick={() => copyToClipboard()}
                />
              </S.Button>
            </div>
          </S.WrapperHeader>
        }
        actions={
          <S.ActionButton>
            <Button
              buttonType="primary"
              value={intl.get('geral.buttonsDefault.close')}
              onClick={() => close()}
              style={{ width: '200px' }}
            />
          </S.ActionButton>
        }
        contentStyle={
          {
            maxWidth: '90%',
            width: '90%'
          }}>
        <S.Wrapper>
          <Table data={tasks} />
        </S.Wrapper>
      </Dialog>
      <S.Button className='btn-ar-out' onClick={() => copyToClipboard()} />
    </S.DialogWrapper>
  )
}

Modal.propTypes = {
  tasks: PropTypes.array,
  open: PropTypes.bool,
  close: PropTypes.func
}

export default Modal
